import { Pipe, PipeTransform, inject } from '@angular/core';
import { ProductTreePath } from '@forgerock/backstage-ui-core';
import { DocService } from '../doc.service';

@Pipe({
  name: 'productVersionPath',
  pure: false,
  standalone: true
})
export class ProductVersionPathPipe implements PipeTransform {
  private docService = inject(DocService);

  path: ProductTreePath;
  productVersion: string;

  transform(path: ProductTreePath): string {
    if (!path) {
      return '';
    }

    if (this.path?.toString() !== path?.toString()) {
      this.path = path;
      const { familyId, productId, minorVersion, version } = path.toMap();

      this.docService.getProductName(productId ?? familyId).then(productName => {
        this.productVersion = [ productName, version ?? minorVersion ].filter(it => !!it).join(' ');
      });
    }

    return this.productVersion;
  }

}
